import script from "./FormTittle.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTittle.vue?vue&type=script&setup=true&lang=js"

import "./FormTittle.vue?vue&type=style&index=0&id=6dbe6ef5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dbe6ef5"]])

export default __exports__